import {useQuery} from "react-query";
import {Client, ThrowStageMapping} from "../../../autogenerate/api.generated.clients";

export function useCompressorThrowStageMapping(frameSerialNumber: string) {
    return useQuery<ThrowStageMapping[]>("compressor-throw-stage-mapping", () => new Client().compressor_GetThrowStageMapping(frameSerialNumber), {staleTime: 300000});
}